"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const SubModuleRegistry_1 = tslib_1.__importDefault(require("./SubModuleRegistry"));
class ModuleRegistryFactory {
    /**
     * Get the module registry. Autodetects whether a local BootModuleRegistry
     * or a remote reference to the module registry of the parent frame is
     * needed.
     *
     * @return The appropriate ModuleRegistry instance
     */
    static getInstance() {
        if (ModuleRegistryFactory.instance) {
            return ModuleRegistryFactory.instance;
        }
        // If no instance, assume we're in a submodule context
        const bootAppRegistry = ModuleRegistryFactory.getBootApplicationRegistry();
        ModuleRegistryFactory.instance = new SubModuleRegistry_1.default(bootAppRegistry);
        return ModuleRegistryFactory.instance;
    }
    static setBootRegistry(bootModuleRegistry) {
        // TODO: We need to consider this side-effect
        // @ts-ignore
        ModuleRegistryFactory.registerModuleRegistry(bootModuleRegistry);
        ModuleRegistryFactory.instance = bootModuleRegistry;
        ModuleRegistryFactory.inSubModule = false;
    }
    static getModuleContext() {
        return ModuleRegistryFactory.instance && ModuleRegistryFactory.instance.getModuleContext();
    }
    static isInSubModule() {
        return ModuleRegistryFactory.inSubModule;
    }
    static getBootApplicationRegistry() {
        return window._fmk_online_moduleRegistry;
    }
    static registerModuleRegistry(jsObject) {
        window._fmk_online_moduleRegistry = jsObject;
    }
    static getParentUrl() {
        return window.parent.location.href;
    }
}
ModuleRegistryFactory.inSubModule = true;
exports.default = ModuleRegistryFactory;
//# sourceMappingURL=ModuleRegistryFactory.js.map